import type { Manifest, v4 } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import { addPatternForBindingChangeOfEnumOPV4 } from '../../../common/decoration/control';
import { getGroupedActionsPathForOP, getHeaderActionsPath } from '../../application';
import { CustomHeaderActionPosition } from './HeaderAction';
import { type RelatedApps } from '@sap/ux-specification-types/src/v4';
import { exportActionMenuAction, exportActionMenuDefaultAction, exportActionMenuMenu } from '../actions';
export class ActionAfterExecutionConfigurationObjectPageHeader
    implements v4.ActionAfterExecutionConfigurationObjectPageHeader
{
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getHeaderActionsPath(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/2c65f07f44094012a511d6bd83f50f2d')
    navigateToInstance?: boolean;

    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getHeaderActionsPath(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    enableAutoScroll?: boolean;
}

export class ObjectPageHeaderActionBase implements v4.ObjectPageHeaderActionBase {
    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    afterExecution?: ActionAfterExecutionConfigurationObjectPageHeader;
}

export class ObjectPageHeaderAction extends ObjectPageHeaderActionBase implements v4.ObjectPageHeaderAction {
    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

export class ObjectPageHeaderActionGroup implements v4.ObjectPageHeaderActionGroup {
    [key: string]: ObjectPageHeaderActionBase | number | v4.ActionPriority;

    @syncRule({
        manifest: {
            path: getGroupedActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getGroupedActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

/**
 * Sync class for Position
 */

export class CustomHeaderActionPositionOP extends CustomHeaderActionPosition {}

export class CustomHeaderActionOPBase implements v4.CustomActionElement {
    @syncRule({
        manifest: {
            path: getHeaderActionsPath,
            export: exportActionMenuMenu
        }
    })
    @validity({
        since: '1.84.0'
    })
    menu: string[];

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    text: string;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    position?: CustomHeaderActionPositionOP;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    visible?: boolean;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    enabled?: boolean;
    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

export class CustomHeaderActionOP extends CustomHeaderActionOPBase implements v4.CustomHeaderActionOP {
    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    press: string;
}

export class ObjectPageHeaderCustomActionMenu
    extends CustomHeaderActionOPBase
    implements v4.ObjectPageHeaderCustomActionMenu
{
    @syncRule({
        manifest: {
            path: getHeaderActionsPath,
            export: exportActionMenuAction
        }
    })
    @validity({
        since: '1.84.0'
    })
    actions?: ObjectPageHeaderCustomActionMenuActions;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath,
            export: exportActionMenuDefaultAction
        }
    })
    @validity({
        since: '1.84.0'
    })
    defaultAction?: string;
}

export class ObjectPageHeaderCustomActionMenuActions implements v4.ObjectPageHeaderCustomActionMenuActions {
    [id: string]: ObjectPageHeaderAction | CustomHeaderActionOP | RelatedApps | ObjectPageHeaderActionGroup;
}
